import type { MFNamesKeys } from '../MFNames';
import { appHosts } from '../appHosts';

export function isHost(mfName: MFNamesKeys) {
	return mfName in appHosts;
}
